import { Tooltip } from "ant-design-vue"
const { ...other } = Tooltip
const YwTooltip = {
  ...other,
  name: "YwTooltip",
}
YwTooltip.install = function (Vue) { 
  Vue.component(YwTooltip.name, Tooltip);
}

export default YwTooltip